<div *ngIf="!isMobileView" class="footer-main text">
  <div class="footer-up">
    <div class="top-button-container" (click)="this._UiHelper.ScrollToTop()">
      <div class="top-button" [ngClass]="{ show: this._UiHelper.showScrollToTopButton }">
        <div class="right">
          <image-loader-utils url="up-arrow" extraClasses=" up"></image-loader-utils>
        </div>
      </div>
    </div>
    <language-dropdown-component></language-dropdown-component>

    <div class="footer-wrap">
      <div class="footer-box">
        <div class="title">{{ 'hightligths' | translate }}</div>
        <div class="item" *ngFor="let league of leagueData" (click)="getMatch(league)">
          {{ league.TournamentText }}
        </div>
      </div>

      <div class="footer-box no-space">
        <div class="title">{{ 'offer' | translate }}</div>
        <a class="item" [routerLink]="['/sports']">{{ 'Sports' | translate }}</a>
        <a class="item" [routerLink]="['/live']">{{ 'live' | translate }}</a>
      </div>
    </div>

    <div class="footer-logo-with-18icon">
      <image-loader-utils extraClasses="logo footer-logo" url="logo" [shared]="false" imageFormat="png"></image-loader-utils>
      <image-loader-utils url="18" extraClasses="svg-18-2"></image-loader-utils>
    </div>

    <social-media-utils></social-media-utils>

    <p class="versionText">
      <code>v.{{ VERSION_TEXT }}</code>
    </p>
    <div class="footer-down"></div>
  </div>
</div>
<div *ngIf="isMobileView" class="footer-mobile-main text">
  <div class="footer-up">
    <div class="top-button-container" (click)="this._UiHelper.ScrollToTop()">
      <div class="top-button" [ngClass]="{ show: this._UiHelper.showScrollToTopButton, hidden: !this._UiHelper.showScrollToTopButton }">
        <div class="right">
          <image-loader-utils url="up-arrow" extraClasses=" up"></image-loader-utils>
        </div>
      </div>
    </div>

    <language-dropdown-component></language-dropdown-component>
    <div class="footer-logo-with-18icon">
      <image-loader-utils extraClasses="logo footer-logo" url="logo" [shared]="false" imageFormat="png"></image-loader-utils>
      <image-loader-utils (click)="this.plus18Link()" url="18" extraClasses="svg-18-2"></image-loader-utils>
    </div>

    <div class="mobile-lock-button-main-container text" *ngIf="('accountLock' | getEnv) && this._UserHelper.isSignedIn">
      <div class="mobile-lock-button">
        <div class="mobile-lock-item">
          <div class="mobile-lock-text">
            {{ 'current_slip_core_text_3' | translate }}
          </div>
          <div id="accountLockButton24" mat-flat-button class="mobile-lock-button">
            {{ '24h_Lock' | translate }}
          </div>
        </div>

        <section class="account-lock-section" *ngIf="progressValue > 0">
          <ng-container *ngIf="holdSeconds != 0">
            <mat-progress-bar class="account-lock-progress-bar" mode="determinate" value="{{ this.progressValue }}"></mat-progress-bar>
            <div class="progress-bar-text">
              {{ holdSeconds }}
            </div>
          </ng-container>
        </section>
      </div>
    </div>
  </div>
  <div class="info-text-container"></div>
  <social-media-utils></social-media-utils>
  <p class="versionText">
    <code>v.{{ VERSION_TEXT }}</code>
  </p>
  <div class="footer-down">
    <div class="more-from">{{ 'more_from_the_game' | translate }}</div>
  </div>
</div>
